import React from "react";
import InputField from "../../forms/input-field";

const StorePaymentHistoryTab = ({ disabled = false }) => {
  return (
    <div className="w-full 2xl:w-[35%] lg:w-[60%] px-5 xl:px-10 mt-5">
      <InputField
        isDisabled={disabled}
        type="text"
        name="payment_history"
        placeholder="Enter Payment History"
        label="Payment History"
        labelWidth="10rem"
      />
    </div>
  );
};

export default StorePaymentHistoryTab;
